goog.provide('el8.data.kareoServiceLocations');
goog.provide('el8.data.serviceLocations');
goog.provide('el8.data.placesOfService');

goog.require('el8.model.base');


el8.data.serviceLocations = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    
    _class.makeContactable();
    _class.addStringProperty('suite', true); // make contactable does not include this in asMap
    
    _class.addStringProperty('name', true);
    _class.addBoolean('primary');
    _class.addIntProperty('placeOfService', true);
    _class.addStringProperty('kareoLocationId', true);

    _class.prototype.getPlaceOfServiceName = function() {
        var placeOfService = this.getPlaceOfService();
        if (placeOfService) {
            
            if (!el8.data.placesOfService.isLoaded()) {
                el8.data.placesOfService.load();
            }

            var details = el8.data.placesOfService.getByKey(placeOfService);
            if (details) {
                return details.getName();
            }
            else {
                // Shouldn't happen, unless we sunset a place-of-service code I guess
                return null;
            }
        }
        else {
            return null;
        }
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['fullAddress'] = this.getFullAddress();
        mapped['addressLine'] = this.getAddressLine();
        mapped['cityStateZip'] = this.getCityStateZip();

        if (el8.data.kareoServiceLocations.isLoaded()) {
            var kareoLoc = el8.data.kareoServiceLocations.getByKey(this.getKareoLocationId());
            mapped['kareoLocationName'] = (kareoLoc) ? kareoLoc.getName() : '';
        }

        return mapped;
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) {
            return el8.service.urls.get('serviceLocations', [id]);
        },
        urlLoad: function() { return el8.service.urls.get('serviceLocations'); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('serviceLocations', [item.getId()]),
                data: JSON.stringify(item.asMap(true, false)),
                success: function(data) {
                    item.populate(data);
                    successCb(item);
                },
                error: errorCb,
                error_msg: function(responseCode, defaultMsg) {
                    if (responseCode === 409) {
                        return 'Your practice already has a location named "'+
                                item.getName()+'." Please choose a unique name.';
                    }
                    return defaultMsg;
                }
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('serviceLocations', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        },
        sortFn: function(a, b) {
            // Sorting primary location first, then alpha by name
            var cmp = b.isPrimary() - a.isPrimary(); // equivalent to '-primary' (primary desc)
            if (cmp === 0) {
                cmp = a.getName() - b.getName();
            }
            return cmp;
        }
    });

    that.getKareoMappedLocations = function() {
        return that.sorted().filter(function(loc) {
            return Boolean(loc.getKareoLocationId());
        });
    };

    return that;

})();


el8.data.kareoServiceLocations = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    
    _class.addStringProperty('name');
    _class.addIntProperty('placeOfService');

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: '/kareo-service-locations/'
    });

})();


el8.data.placesOfService = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    
    _class.addStringProperty('name');
    _class.addStringProperty('code');

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        key: 'code',
        urlLoad: '/pos-codes/',
        sortFn: function(a, b) {
            // Sort by POS code
            var cmp = a.getCode() - b.getCode();
            return cmp;
        }
    });

})();

